import Portal from '../Portal';
import styles from '../../styles/MediaPicker.module.scss';
import LeftArrowIcon from '../../../icons/LeftArrowIcon';
import MediaCard from './MediaCard';

export default function MediaPicker({ type, open, onClose, onSelect, onClear, items }) {
  return (
    <Portal>
      <div className="shakeScope">
        <div className={styles.backdrop} onClick={onClose} />
        <section className={styles.sheet} role="dialog" aria-modal="true">
          <header className={styles.header}>
            <button className={styles.back} onClick={onClose} aria-label="Close">
              <LeftArrowIcon width={16} height={16} />
            </button>
            <strong>Select {type}</strong>
          </header>

          <div className={styles.body}>
            {!items?.length ? (
              <div className={styles.empty}>No {type}s found</div>
            ) : (
              <div className={styles.list}>
                {items.map((it) => (
                  <MediaCard
                    key={it.id}
                    type={type}
                    url={it.signedUrl || it.url}
                    name={it.name}
                    onSelect={() => onSelect(it)}
                    canClear={false}
                  />
                ))}
              </div>
            )}
          </div>
        </section>
      </div>
    </Portal>
  );
}
